import { tokenKey } from './credentials';

export async function makeAPICall(method, url, body) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const token = localStorage.getItem(tokenKey);
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  try {
    let req = fetch(`${process.env.PUBLIC_URL}${url}`, {
      method,
      headers,
      body: JSON.stringify(body)
    });
    return req;
  } catch (er) {
    throw er;
  }
}
